import { toFarsiNumber } from "@utils/digits";

export const productCardDurationCalculator = (
  duration:
    | {
        hours?: number;
        minutes?: number;
        rounded_in_hour?: number;
        in_minutes?: number;
      }
    | null
    | undefined
) => {
  const { hours, minutes, rounded_in_hour, in_minutes } = duration || {};

  const minutesNumber =
    typeof in_minutes === "number" ? in_minutes : minutes || null;

  const hoursNumber =
    typeof rounded_in_hour === "number" ? rounded_in_hour : hours || null;

  if (!minutesNumber && !hoursNumber) return "";

  const isLessThan60Mins =
    typeof minutesNumber === "number" && minutesNumber < 60;

  if (minutesNumber && isLessThan60Mins)
    return `${toFarsiNumber(minutesNumber || 0)} دقیقه`;
  else if (hoursNumber) return `${toFarsiNumber(hoursNumber || 0)} ساعت`;
  else return "";
};
